import { NgModule } from '@angular/core';
import { AccessDeniedComponent } from './access.denied/access.denied.component';
import { PageNotFoundComponent } from './page.not.found/page.not.found.component';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';

@NgModule({
    declarations: [AccessDeniedComponent, PageNotFoundComponent],
    imports: [CommonModule, StoreModule],
    exports: [AccessDeniedComponent, PageNotFoundComponent],
    providers: [],
})
export class ErrorPageModule {

}
